import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import Alert from 'react-s-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch, faPlus, faCoins, faThumbsUp, faThumbsDown,
    faRandom
} from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import moment from 'moment';
import { ThemeContext } from '../Common/ThemeProvider';
import DatePicker from 'react-datepicker';
import ReactTooltip from "react-tooltip";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Gift from '../../Images/Gift.gif';
import Work from '../../Images/Work.gif';
import Earned from '../../Images/Earned.gif';
import { FetchUsers } from '../Common/Services/UserService';
import UserList from './ReusableComponents/UserList';

const rewards = {
    Points: 0,
    CreditDate: new Date(),
    CreditTo: "",
    Type: 0,
    IsTransfer: 0,
    ExpiryDate: new Date(),
    JobID: 0,
    Remarks: ""
};

const RewardType = [{
    label: "Welcome Voucher",
    value: 1
},
{
    label: "Earned Voucher",
    value: 2
},
{
    label: "Work Related",
    value: 3
}];

const MerchantRewards = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [usersData, setusersData] = useState([]);
    const [FilterUsers, setFilterUsers] = useState([]);
    const [Rewards, setRewards] = useState([]);
    const [SelectedUsers, setSelectedUsers] = useState({});
    const [displayAddRewardModel, setdisplayAddRewardModel] = useState("none");
    const [displayWalletHistoryModel, setdisplayWalletHistoryModel] = useState("none");
    const [TransferClick, setTransferClick] = useState(0);
    const [AddRewardData, setAddRewardData] = useState(rewards);
    const [TransferUsers, setTransferUsers] = useState([]);
    const [Wallet, setWallet] = useState({});
    const [WalletHistory, setWalletHistory] = useState([]);


    useEffect(() => {
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUsersSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = usersData.filter(c => c.FirstName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.LastName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                (c.Organization.length > 0 && c.Organization[0].Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase())));
            setFilterUsers(userSearchData);
        }
        else {
            setFilterUsers(usersData);
        }
    };

    const FetchUsersData = () => {
        FetchUsers(null, UserSuccess, Failure);
    };

    const UserSuccess = (data) => {
        setusersData(data);
        setFilterUsers(data);

        let userlist = [];
        data.forEach(user => {
            if (user.Organization.length > 0) {
                userlist.push({ value: user._id, label: user.FirstName + " " + user.LastName + " [" + user.Organization[0].Name + "]" });
            }
        });

        setTransferUsers(userlist);
    };

    const GetMerchantRewards = (userData) => {
        setSelectedUsers(userData);
        setAddRewardData({ ...AddRewardData, "CreditTo": userData._id });
        Axiosfetch(baseURL + "GetRewardsByAgentID", "POST", { ID: userData._id }, RewardsSuccess, Failure);
    };

    const RewardsSuccess = (data) => {
        if (data.length > 0) {
            setRewards(data);
        }
        else {
            setRewards([]);
        }
    };

    const AddNewreward = () => {
        setdisplayAddRewardModel("block");
        setTransferClick(0);
    };

    const hideWalletHistory = () => {
        setdisplayWalletHistoryModel("none");
    };

    const hideRewardAdd = () => {
        setdisplayAddRewardModel("none");
    };

    const onCreditDateChange = (date) => {
        setAddRewardData({ ...AddRewardData, "CreditDate": date });
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setAddRewardData({ ...AddRewardData, [e.target.name]: value });
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setAddRewardData({ ...AddRewardData, [e.target.name]: value });
    };

    const ValidateAddReward = (rewards) => {
        let rewardErr = "";
        if (rewards.Points === 0) {
            rewardErr = "Please enter valid Points";
        }
        else if (rewards.CreditDate > new Date()) {
            rewardErr = "Please enter valid Date";
        }
        else if (rewards.CreditTo === "") {
            rewardErr = "Please select Agent";
        }
        else if (rewards.Type === 0) {
            rewardErr = "Please enter Reward Type";
        }
        else if (rewards.Remarks.trim() === "") {
            rewardErr = "Please enter valid Remarks";
        }

        if (rewardErr !== "") {
            Alert.error(rewardErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    }

    const AddRewardDetails = () => {
        if (TransferClick === 0) {
            if (ValidateAddReward(AddRewardData)) {
                Axiosfetch(baseURL + "CreateMerchantRewards", "POST", AddRewardData, AddRewardsSuccess, Failure);
            }
        }
        else {
            TransferWalletPoints();
        }
    };

    const TransferWalletPoints = () => {
        if (Wallet.Points && AddRewardData.Points > 0 && Wallet.Points >= AddRewardData.Points && AddRewardData.CreditTo !== "" && AddRewardData.Remarks.trim() !== "") {
            let voucher = AddRewardData;
            voucher.IsTransfer = 1;
            voucher.Type = 3;
            voucher.JobID = 0;
            voucher.ExpiryDate = new Date();
            Axiosfetch(baseURL + "CreateMerchantRewards", "POST", voucher, TransferSuccess, Failure);
        }
        else {
            var error = ""
            if (Wallet.Points && Wallet.Points < AddRewardData.Points) {
                error = "Transfer Points cannot be greater than voucher Points";
            }
            else {
                error = "Invalid Data";
            }
            Alert.error(error, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const UpdateWalletPoints = () => {
        if (Wallet && Wallet._id !== "") {
            let points = Wallet.Points - AddRewardData.Points;
            Axiosfetch(baseURL + "UpdateWallet", "POST", { _id: Wallet._id, Points: points }, UpdateTransferLog, Failure);
        }
    };

    const UpdateTransferLog = (data) => {
        if (data.success) {
            const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

            Axiosfetch(baseURL + "CreateTransferLog", "POST", {
                WalletID: Wallet._id,
                From: SelectedUsers._id,
                To: AddRewardData.CreditTo,
                WalletPoints: Wallet.Points,
                TransferPoints: AddRewardData.Points,
                TransferBy: userData._id
            }, AddRewardsSuccess, Failure);
        }
        else {
            Alert.error("Error Transferring Wallet Points", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const TransferSuccess = (data) => {
        if (data.success) {
            UpdateWalletPoints();
        }
        else {
            Alert.error("Error Transferring Wallet Points", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const AddRewardsSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            hideRewardAdd();

            if (SelectedUsers._id !== "") {
                GetMerchantRewards(SelectedUsers);
                setTransferClick(0);
            }
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnRewardTypeChange = (RewardTypeData) => {
        let rewardData = parseInt(RewardTypeData ? RewardTypeData.value : 0);
        if (rewardData > 0) {
            setAddRewardData({ ...AddRewardData, "Type": rewardData });
        }
    }

    const LiquidateReward = (rewardID) => {
        Axiosfetch(baseURL + "EditMerchantRewards", "POST", { ID: rewardID, Status: 2 }, AddRewardsSuccess, Failure);
    };

    const DiscardReward = (rewardID) => {
        Axiosfetch(baseURL + "EditMerchantRewards", "POST", { ID: rewardID, Status: 3 }, AddRewardsSuccess, Failure);
    };

    const TransferPoints = (rewards) => {
        FetchUsersData();
        setTransferClick(1);
        setAddRewardData({ ...AddRewardData, "Points": rewards.Points });
        setWallet(rewards);
        setdisplayAddRewardModel("block");
    };

    const OnTransferUserChange = (user) => {
        let userID = user ? user.value : "";
        setAddRewardData({ ...AddRewardData, "CreditTo": userID });
    };

    const GetTransferHistory = (walletId) => {
        Axiosfetch(baseURL + "GetAllTransferLogByWalletID", "POST", { WalletID: walletId }, WalletHistorySuccess, Failure);
    };

    const WalletHistorySuccess = (data) => {
        if (data.length > 0) {
            setWalletHistory(data);
            setdisplayWalletHistoryModel("block");
        }
        else {
            Alert.warning("No Wallet Transfer History", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>MFI e-Batua - Digital Wallet</h5>
                    </div>
                </div>
                <div className="row" style={{ height: "72vh", marginTop: "10px", marginLeft: "5px", marginRight: "5px" }}>
                    <div className="col-md-5" style={{
                        borderRight: "1px solid #ccc",
                        borderTop: "1px solid #ccc"
                    }}>
                        <div style={{ height: "72vh", overflow: "auto", scrollbarWidth: "none", padding: "0 10px 10px 10px" }}>
                            <div style={{ marginBottom: "20px", position: "relative" }}>
                                <input type="text" name="Name" placeholder="Search User..."
                                    className="input-control" style={{ outline: "none", marginRight: "10px", borderRadius: "20px", paddingLeft: "40px", borderTop: "none", borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
                                    onChange={e => onUsersSearch(e.target.value)}></input>
                                <div className={`${CurrentTheme}Color`} style={{ fontSize: "1.1rem", position: "absolute", left: "89%", top: "13%" }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            <div style={{ height: "65vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                                <UserList FilterUsers={FilterUsers} GenerateQRCode={GetMerchantRewards} SelectedUsers={SelectedUsers}></UserList>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7" style={{
                        borderL: "1px solid #ccc",
                        borderTop: "1px solid #ccc", paddingTop: "10px"
                    }}>
                        {SelectedUsers._id !== undefined &&
                            SelectedUsers._id.toString() !== "" && (<div>
                                <div className="row" style={{ paddingBottom: "10px", marginBottom: "10px", borderBottom: "1px solid #ccc" }}>
                                    <div className="offset-md-1 col-md-10 col-sm-10 align-center"> Wallet [{Rewards.filter(r => r.Status !== 3).length}] - {SelectedUsers._id !== undefined ?
                                        (SelectedUsers.FirstName + " " + SelectedUsers.LastName) : ""}</div>
                                    <div data-tip="Add Voucher" onClick={AddNewreward}
                                        className={`col-md-1 col-sm-1 align-right cursor ${CurrentTheme}Color`}>
                                        <FontAwesomeIcon icon={faPlus} />
                                        <ReactTooltip></ReactTooltip>
                                    </div>
                                </div>
                                <div style={{ height: "65vh", overflow: "auto", scrollbarWidth: "none", padding: "0 10px 10px 10px" }}>
                                    {Rewards.length > 0 && Rewards.map(reward => (
                                        reward.Status !== 3 && (
                                            <div key={reward._id} style={{ border: "1px solid #ccc", margin: "15px 0", borderRadius: "6px", overflow: "auto", display: "flex", justifyContent: "space-between" }}>
                                                <div style={{ margin: "auto" }} title={reward.IsTransfer === 0 ? "Self Wallet" : "Transfer Wallet"}>
                                                    <div style={{ textAlign: "center", fontSize: "6rem", color: "rgb(0, 194, 199)" }}>
                                                        {/* <FontAwesomeIcon icon={reward.IsTransfer === 0 ? faWallet : faRandom} /> */}
                                                        {reward.Type === 1 && (<img alt="truck" width="150px" height="150px" src={Gift}></img>)}
                                                        {reward.Type === 3 && (<img alt="work" width="150px" height="150px" src={Work}></img>)}
                                                        {reward.Type === 2 && (<img alt="work" width="150px" height="150px" src={Earned}></img>)}
                                                    </div>
                                                    <div style={{ color: "rgb(0, 194, 199)", textAlign: "center" }}>{reward.Type && RewardType[reward.Type - 1].label}</div>
                                                </div>
                                                <div style={{ width: "80%", borderLeft: "1px solid #ccc" }}>
                                                    <table className="table">
                                                        <tbody>
                                                            <tr className="text-center" style={{ backgroundColor: "#00c2c7", color: "white" }}>
                                                                <td>Wallet #</td>
                                                                <td ><span style={{ cursor: "pointer" }} title="Click for Transfer History" onClick={() => GetTransferHistory(reward._id)}>{reward._id.toUpperCase()}</span>
                                                                    {reward.Status === 1 && (<div style={{ float: "right" }}>
                                                                        <span onClick={() => LiquidateReward(reward._id)} title="Click to Liquidate" style={{ color: "#ffdf32", cursor: "pointer", paddingRight: "15px" }}><FontAwesomeIcon icon={faCoins} /></span>
                                                                        <span onClick={() => DiscardReward(reward._id)} title="Click to Discard" style={{ color: "#b00b1e", cursor: "pointer", paddingRight: "15px" }}><FontAwesomeIcon icon={faThumbsDown} /></span>
                                                                        <span onClick={() => TransferPoints(reward)} title="Transfer" style={{ color: "#ffff00", cursor: "pointer" }}><FontAwesomeIcon icon={faRandom} /></span>
                                                                    </div>)}
                                                                    {reward.Status === 2 && (<span title="Liquidated" style={{ float: "right", color: "green", cursor: "pointer" }}><FontAwesomeIcon icon={faThumbsUp} /></span>)}
                                                                    {reward.Status === 3 && (<span title="Discarded" style={{ float: "right", color: "#b00b1e", cursor: "pointer" }}><FontAwesomeIcon icon={faThumbsDown} /></span>)}
                                                                </td>
                                                            </tr>
                                                            <tr className="text-center">
                                                                <td>Points</td>
                                                                <td>
                                                                    <span style={{ paddingLeft: "2px", fontSize: "2rem" }}> {reward.Points}</span></td>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#f1f1f1" }}>
                                                                <td></td>
                                                                <td className="text-center">{moment(reward.CreditDate).local().format('DD MMM YYYY, hh:mm:ss A')}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>)
                                    ))}
                                </div>
                            </div>)}
                    </div>
                </div>
            </div>
            <div id="myModalReward" className="modal" style={{ display: displayAddRewardModel }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>{(TransferClick === 0 ? "Add Wallet Points" : "Transfer Wallet Points")}</span>
                        <span className="close" onClick={hideRewardAdd}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <h5>Points<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <input type="number" min="0.00" step="any" name="Points"
                                                className="form-control"
                                                onChange={e => onNumberChange(e)}
                                                value={AddRewardData.Points}></input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>Credit Date<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <DatePicker name="CreditDate" selected={AddRewardData.CreditDate}
                                                onChange={onCreditDateChange}
                                                showTimeSelect className="form-control"
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                        </td>
                                    </tr>
                                    {TransferClick === 0 && (<tr>
                                        <td><h5>Type<span className="mandatoryStar">*</span></h5></td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Type"
                                                    options={RewardType}
                                                    onChange={OnRewardTypeChange}></Select>
                                            </div>
                                        </td>
                                    </tr>)}
                                    {TransferClick === 1 && (<tr>
                                        <td><h5>Transfer To<span className="mandatoryStar">*</span></h5></td>
                                        <td>
                                            <div>
                                                <Select isClearable={true} isSearchable={true} placeholder="Select Partner"
                                                    options={TransferUsers}
                                                    onChange={OnTransferUserChange}></Select>
                                            </div>
                                        </td>
                                    </tr>)}
                                    <tr>
                                        <td>
                                            <h5>Remarks<span className="mandatoryStar">*</span></h5>
                                        </td>
                                        <td>
                                            <textarea
                                                onChange={e => onTextChange(e)}
                                                rows="2"
                                                className="form-control" name="Remarks"
                                                value={AddRewardData.Remarks}></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={AddRewardDetails}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={hideRewardAdd}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModalWalletHistory" className="modal" style={{ display: displayWalletHistoryModel }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Wallet History</span>
                        <span className="close" onClick={hideWalletHistory}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12" style={{ height: "40vh", overflow: "auto" }}>
                            <table className="table align-center">
                                <thead>
                                    <tr>
                                        <th>Transfer To</th>
                                        <th>Points</th>
                                        <th>Transfer By</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {WalletHistory.length > 0 && WalletHistory.map((wallet, index) => (
                                        <tr key={index}>
                                            <td>
                                                {wallet.To[0].FirstName + " " + wallet.To[0].LastName}
                                            </td>
                                            <td>
                                                {wallet.TransferPoints}
                                            </td>
                                            <td>
                                                {wallet.TransferBy[0].FirstName + " " + wallet.TransferBy[0].LastName}
                                            </td>
                                            <td>
                                                {moment(wallet.createdAt).local().format("DD/MM/YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MerchantRewards;